import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface SipLoginStatistic {
  number: string;
  label: string;
  isAvailable?: boolean;
}

@Component({
  selector: 'app-sip-login-card',
  templateUrl: './sip-login-card.component.html',
  styleUrls: ['./sip-login-card.component.scss']
})
export class SipLoginCardComponent {
  heading: string = 'Call Center para operadores';
  buttonText: string = 'Iniciar sesión';
  @Input() statistics: SipLoginStatistic[] = [
    { number: '124', label: 'Horas\nRegistradas' },
    { number: '300', label: 'Llamadas\nAtendidas' },
    { number: '6', label: 'Operadores\nDisponibles', isAvailable: true }
  ];

  @Output() login = new EventEmitter<void>();

  onLoginClick(): void {
    this.login.emit();
  }
}
